import React from 'react';
import UserGroupIcon from '@heroicons/react/outline/UserGroupIcon.js';
import { BlockType } from '../../types/index.js';
import { MemberListBlock as Component } from './Block.js';
export const RegisteredMemberListBlock = ({ $t, }) => ({
    recommendedName: 'MemberList',
    Component,
    config: {
        type: BlockType.Block,
        displayName: $t({
            id: 'Generics.Members',
            defaultMessage: '{MEMBERS_CC}',
        }),
        deprecated: true,
        Icon: React.createElement(UserGroupIcon, null),
    },
});
//# sourceMappingURL=registered.js.map